/**
 * FAQ Block JavaScript
 */
class FAQ {

	/**
	 * Initialize FAQ functionality for all FAQ blocks
	 */
	static init() {

		document.querySelectorAll( '.b-faq' ).forEach( faq => new FAQ( faq ) );

	}

	/**
	 * Constructor for FAQ class
	 * @param {HTMLElement} element The FAQ block element
	 */
	constructor( element ) {

		this.element = element;
		this.mode = this.element.getAttribute( 'data-mode' ) || 'accordion';
		this.animateToggle = this.element.getAttribute( 'data-animate' ) === 'true';
		this.faqItems = this.element.querySelectorAll( '.b-faq__item' );

		this.initialize();

	}

	/**
	 * Initialize all FAQ items
	 */
	initialize() {

		this.faqItems.forEach( item => this.setUpFAQItem( item ) );

	}

	/**
	 * Set up a single FAQ item with toggle functionality
	 * @param {HTMLElement} item The FAQ item element
	 */
	setUpFAQItem( item ) {

		const toggleButtons = item.querySelectorAll( '.js-faq-toggle' );
		const content = item.querySelector( '.js-faq-content' );

		toggleButtons.forEach( button => {

			button.addEventListener( 'click', () =>
				this.handleToggleClick( item, button, content )
			);

		} );

		if ( this.animateToggle && content ) {

			content.style.maxHeight = '0px';

		}

	}

	/**
	 * Handle toggle button click
	 * @param {HTMLElement} item The FAQ item element
	 * @param {HTMLElement} button The toggle button element
	 * @param {HTMLElement} content The content element to show/hide
	 */
	handleToggleClick( item, button, content ) {

		if ( !content ) {

			return;

		}

		if ( this.mode === 'accordion' && !item.classList.contains( 'b-faq__item--open' ) ) {

			this.closeOtherItems( item );

		}

		this.toggleFAQItem( item, button, content );

	}

	/**
	 * Close other FAQ items
	 * @param {HTMLElement} currentItem The currently toggled item
	 */
	closeOtherItems( currentItem ) {

		this.faqItems.forEach( otherItem => {

			if ( otherItem !== currentItem && otherItem.classList.contains( 'b-faq__item--open' ) ) {

				otherItem.classList.remove( 'b-faq__item--open' );
				const otherButtons = otherItem.querySelectorAll( '.js-faq-toggle' );
				const otherContent = otherItem.querySelector( '.js-faq-content' );

				otherButtons.forEach( btn => btn.setAttribute( 'aria-expanded', 'false' ) );

				if ( otherContent ) {

					if ( this.animateToggle ) {

						otherContent.style.maxHeight = '0px';

					}
					otherContent.setAttribute( 'aria-hidden', 'true' );

				}

			}

		} );

	}

	/**
	 * Toggle the FAQ item open/closed state
	 * @param {HTMLElement} item The FAQ item element
	 * @param {HTMLElement} button The toggle button element
	 * @param {HTMLElement} content The content element to show/hide
	 */
	toggleFAQItem( item, button, content ) {

		if ( !content ) {

			return;

		}

		const isOpen = !item.classList.contains( 'b-faq__item--open' );

		if ( isOpen ) {

			item.classList.add( 'b-faq__item--open' );

		} else {

			item.classList.remove( 'b-faq__item--open' );

		}

		if ( this.animateToggle ) {

			content.style.maxHeight = isOpen ? `${content.scrollHeight}px` : '0px';

		}

		content.setAttribute( 'aria-hidden', !isOpen );
		const allButtons = item.querySelectorAll( '.js-faq-toggle' );
		allButtons.forEach( btn => btn.setAttribute( 'aria-expanded', isOpen ) );

	}

}

document.addEventListener( 'DOMContentLoaded', FAQ.init );
